import { IStore } from 'Store/.';
import { createSelector } from 'reselect';
import { getAllEventsMergedByID } from 'Pages/EventsPage/Redux/selectors';

const getIsFetching = (state: IStore) => state.banners.isFetching;
const getFetchFailed = (state: IStore) => state.banners.isFetchFailed;
const getBanners = (state: IStore) => state.banners.content;

const getAboutBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.aboutContent : null,
);

const getSocialMediaBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.socialMediaContent : null,
);

const getNewsLetterBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.newsLetterContent : null,
);

const getAgentsBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.agentsContent : null,
);

const getECommerceBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.eCommerceContent : null,
);

const getBookingsBanner = createSelector(
  [getBanners], (startPage) => startPage ? startPage.bookingsContent : null,
);

const getSlidingMessage = createSelector(
  [getBanners], (startPage) => 
    startPage && startPage.messageSliders && 
      startPage.messageSliders.length > 0 ? startPage.messageSliders[0] : null,
);

const getHeroEventIDs = createSelector(
  [getBanners], (startPage) => startPage ? startPage.heroEventIDs : [],
);

const getHeroEvents = createSelector(
  [getHeroEventIDs, getAllEventsMergedByID],
  (eventIDs, events) => {

    if (!eventIDs.length && events && events.length) {
      return events.slice(0, 3);
    }

    const heroEvents: Julius.Website.EventOverviewViewModel[] = [];

    eventIDs.map(id => {
      const event = events.find(e => e.id === id);
      
      if (event) {
        heroEvents.push(event);
      }
    });

    while (heroEvents.length < 3 && events.length >= 3) {
      heroEvents.push(events[heroEvents.length]);
    }

    return heroEvents;
  },
);

export {
  getIsFetching,
  getAboutBanner,
  getSocialMediaBanner,
  getNewsLetterBanner,
  getAgentsBanner,
  getECommerceBanner,
  getBookingsBanner,
  getHeroEvents,
  getSlidingMessage,
};


// WEBPACK FOOTER //
// ./src/store/Banners/selectors.tsx